// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4df704bb","513":"7e415f22","703":"ff087d58","787":"3ce4cc4d"}[chunkId] + ".chunk.js";
};